import { render, staticRenderFns } from "./BRSPopup.vue?vue&type=template&id=488e9ebb&scoped=true&"
import script from "./BRSPopup.vue?vue&type=script&lang=ts&"
export * from "./BRSPopup.vue?vue&type=script&lang=ts&"
import style0 from "./BRSPopup.vue?vue&type=style&index=0&id=488e9ebb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e9ebb",
  null
  
)

export default component.exports